export interface DelinquentClaimsStatisticPayload {
  isShowed: boolean;
  paidRequiringDocsCount: number;
  repaymentRequiredCount: number;

  lockedPursesCount: number | null;
}

export enum DelinquentClaimsStatisticTileType {
  PaidRequiringDocs = 'PaidRequiringDocs',
  RepaymentRequired = 'RepaymentRequired',
  LockedPurses = 'LockedPurses',
}

export interface DelinquentClaimsStatisticTileConfig {
  type: DelinquentClaimsStatisticTileType;
  testId: string;
  label: string;
  value?: number;
}

export interface DelinquentClaimsStatisticTileProps extends DelinquentClaimsStatisticTileConfig {
  isLoading?: boolean;
}

export interface UseDelinquentClaimsStatisticLogicParams {
  data: DelinquentClaimsStatisticPayload | null;
  isLoading?: boolean;
}
